<template>
  <file-pond
    class="c-upload"
    name="upload"
    ref="pond"
    :label-idle="labelIdle"
    v-bind:allow-multiple="allowMultiple"
    :accepted-file-types="['image/jpeg', 'image/png', 'application/pdf']"
    labelFileTypeNotAllowed="Dateiformat nicht unterstützt"
    fileValidateTypeLabelExpectedTypes="Erlaubt sind {allButLastType} oder {lastType}"
    maxFileSize="10MB"
    labelMaxFileSizeExceeded="Datei ist zu groß"
    labelMaxFileSize="Maximale Dateigröße ist {filesize}"
    v-bind:files="myFiles"
    v-on:init="handleFilePondInit"
    :fileRenameFunction="handleFileRenameFunction"
    :captureMethod="captureMethod"
  />
</template>

<script>
// Import Vue FilePond
import vueFilePond from "vue-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Import FilePond plugins
// Please note that you need to install these plugins separately

// Import image preview plugin styles
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileRename from "filepond-plugin-file-rename";

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateSize,
  FilePondPluginFileRename
);

export default {
  components: {
    FilePond,
  },
  props: {
    handleFileRenameFunction: {
      type: Function,
      required: false,
      default: null,
    },
    allowMultiple: {
      required: false,
      type: Boolean,
      default: false,
    },
    captureMethod: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      myFiles: [],
      labelIdle:
        '<svg version="1.1" height="40" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 2000 2000" style="enable-background:new 0 0 2000 2000;" xml:space="preserve"><style type="text/css">.st0{fill:#5E58BE;}</style><g id="Layer_1_00000016050793976196146910000018062605263254434462_"></g><g id="Layer_2_00000076602876212205253150000003716283904030956707_"><g><path class="st0" d="M929,1536.3l-0.1-1397.5h142.3V1536L929,1536.3z"/><path class="st0" d="M1,1857.9l1997.9-0.1v0c0,78.6-63.7,142.3-142.3,142.3H143.6C65,2000,1.3,1936.4,1,1857.9L1,1857.9z"/><path class="st0" d="M143.2,1313.9l0.1,543.8H1V1314L143.2,1313.9z"/><path class="st0" d="M1998.8,1313.9l0.1,543.8h-142.3V1314L1998.8,1313.9z"/><polygon class="st0" points="40.4,778.5 999.7,0 1976.8,778.1 1888.3,889.3 1000.6,182.6 130,888.9 		"/></g></g></svg>',
    };
  },
  methods: {
    handleFilePondInit: function () {
      console.log("FilePond has initialized");

      // FilePond instance methods are available on `this.$refs.pond`
    },
    // handleFileRenameFunction: (file) => {
    //   return `behandlungsplan${file.extension}`;
    // },
  },
};
</script>

<style lang="scss">
.c-upload {
  .filepond--root {
    font-size: 1.4rem;
  }
  .filepond--credits {
    display: none;
  }
  .filepond--panel-root {
    background-color: transparent;
    border: 1px solid var(--ion-color-primary);
  }
}
</style>
